import React, { useState, useEffect } from "react";
import axios from "axios";
import { Rating } from "react-simple-star-rating";
import { useSelector } from "react-redux";
import moment from "moment";
import { ProgressBar } from "react-bootstrap";
import jwtEncode from "jwt-encode";
import { useParams } from "react-router-dom";
import { StarIcon } from "../../../SvgIconsData";


const ModuleReview = ({ setRatingAverage , setTotalReviews}) => {

    const userData = useSelector((state) => state.userSlice);
    const isLoggedIn = userData.token.length > 0 ? true : false;
    const configData = useSelector((state) => state.configSlice);
    let params = useParams();
    const moduleUUID = params.uuid;
    const [reviewsList, setReviewsList] = useState([]);
    const [submitReview, setSubmitReview] = useState(false);
    const [ownReviewFind, setOwnReviewFind] = useState(false);
    const [average, setAverage] = useState(0);
    const [ratingGraph, setRatingGraph] = useState({
      Excellent: 0,
      "Very Good": 0,
      Average: 0,
      Poor: 0,
      Terrible: 0,
    });

    const [reviewFind, setReviewFind] = useState({
      rating: 0,
      review: "",
      uuid : null
    });
  
      const debounce = (func, delay) => {
        let timer;
        return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => func.apply(this, args), delay);
        };
      };

    const getModuleReview = async () => {
        try {
          const response = await axios.get(
            `${configData.config.UNO_URL}/api/application/getRating/${moduleUUID}`,
            {
              headers: {
                Authorization: `Bearer `,
                "Content-Type": "application/json",
              },
            }
          );
    

          if (response.data.data.length > 0) {
            const newRatingGraph = {
              Excellent: 0,
              "Very Good": 0,
              Average: 0,
              Poor: 0,
              Terrible: 0,
            };
            response.data.data.forEach((item) => {
              const ratingValue = item.data.rating;
              switch (ratingValue) {
                case 5:
                  newRatingGraph["Excellent"] += 1;
                  break;
                case 4:
                  newRatingGraph["Very Good"] += 1;
                  break;
                case 3:
                  newRatingGraph["Average"] += 1;
                  break;
                case 2:
                  newRatingGraph["Poor"] += 1;
                  break;
                case 1:
                  newRatingGraph["Terrible"] += 1;
                  break;
                default:
                  break;
              }
            });
            setAverage(response.data.average);
            setRatingAverage(response.data.average);
            setRatingGraph({ ...newRatingGraph });
            setTotalReviews(response.data.data.length)
            setReviewsList(response.data.data);
            
            if (userData.user.uuid && response.data.data.length) {
              let find = response.data.data.filter((e) => e.user.uuid == userData.user.uuid);
    
              if( find.length > 0 ){
              setOwnReviewFind(true);
              setReviewFind({
                rating: find[0].data.rating,
                review: find[0].data.review,
                uuid :   find[0].uuid
              });
            }
    
            }
          }
        } catch (error) {
          console.log(error);
        }
      };

      const handleRating = (rate) => {
        setReviewFind(pre => ({ ...pre , rating : rate }));
      };

    const handleSaveReview = async () => {
        try {
          setSubmitReview(true);
          let data = {
            rating: reviewFind.rating,
            review: reviewFind.review,
            applicationId: configData.config.applicationId,
          };
    
          await axios.post(`${configData.config.UNO_URL}/api/application/save/review/${moduleUUID}`, data, {
              headers: {
                Authorization: `Bearer ${userData.token}`,
                "Content-Type": "application/json",
              },
            }
          );
          getModuleReview();
          setReviewFind({
            rating: 0,
            review: null,
            uuid : null
          })


        } catch (error) {
          console.log(error);
        } finally {
          setSubmitReview(false);
        }
      };

    const handleUpdateReview = async () => {
        try {
          setSubmitReview(true);
          let data = {
            rating: reviewFind.rating,
            review: reviewFind.review,
            uuid: reviewFind.uuid,
          };
    
          await axios.post(`${configData.config.UNO_URL}/api/application/update/review/${moduleUUID}`, data, {
              headers: {
                Authorization: `Bearer ${userData.token}`,
                "Content-Type": "application/json",
              },
            }
          );
          getModuleReview();
          setReviewFind({
            rating: 0,
            review: null,
            uuid : null
          })

        } catch (error) {
          console.log(error);
        } finally {
          setSubmitReview(false);
        }
      };

    const debounceHandleSaveReview = debounce(handleSaveReview, 1000);
    const debounceHandleUpdateReview = debounce(handleUpdateReview, 1000);

    const login = () => {
        const currentURL = window.location.href;
        const baseUrl = new URL(currentURL).origin;
        const payload = {
          origin: baseUrl,
        };
        const token = jwtEncode(payload, "");
        return (window.location.href = `${configData.config.redirectUri}?referrer=${token}`);
      };

      useEffect(() => {
        if (moduleUUID?.length > 0) {
          getModuleReview();
        }
      }, [moduleUUID]);



  return (
        <div>
            <div className="row w-100">
                <div className="col-md-6">
                <div className="rating-here">
                    <h5 id="reviews"> {ownReviewFind ? "Your review" : "Post a review"}</h5>

                      <div className="row w-100">
                        <div className="col-md-12">
                        <div className="wrtie-review">
                            <div className="row">
                            <div className="col-md-12">
                                <div className="quesformbox mt-2 raiting">
                                <p className="mb-2">Ratings</p>
                                <Rating 
                                   onClick={handleRating} 
                                   initialValue={reviewFind.rating} 
                                //    readonly={ ownReviewFind ? true : false} 
                                   />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="quesformbox mt-2">
                                <p>
                                    Review <span>*</span>
                                </p>
                                <textarea
                                    name="contactName"
                                    placeholder="Review"
                                    type="text"
                                    className="input mt-2"
                                    value={reviewFind.review}
                                    rows={5}
                                    // readOnly = { ownReviewFind ? true : false }
                                    onChange={(e) => setReviewFind(pre => ({...pre , review : e.target.value}) )}
                                />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="quesformbox mt-2">
                                { isLoggedIn ? (

                                    ownReviewFind ?
                                      <button className="reset-btn" onClick={ submitReview ? null : debounceHandleUpdateReview }>
                                       { submitReview ? 
                                        <div className="loader">
                                        <span className="bar"></span>
                                        <span className="bar"></span>
                                        <span className="bar"></span>
                                        </div>
                                         : 
                                        "Update"
                                      }
                                    </button>
                                    :
                                    <button className="reset-btn" onClick={ submitReview ? null : debounceHandleSaveReview }>
                                    { submitReview ? 
                                        <div className="loader">
                                        <span className="bar"></span>
                                        <span className="bar"></span>
                                        <span className="bar"></span>
                                        </div>
                                      : 
                                        "Submit"
                                    }
                                    </button>



                                ) 
                                 : 
                                <button className="reset-btn" onClick={login}> Login and Submit </button>
                                }
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                      </div>

                    {reviewsList.length > 0 && (
                    <>
                        <div className="rating mt-4">
                        <StarIcon /> {Number.isInteger(average) ? average : average.toFixed(1)} out of 5<span> ({reviewsList.length} Reviews)</span>
                        </div>

                        <div className="raiting-dis">
                        {Object.keys(ratingGraph).map((e, i) => {
                            const percentage = (ratingGraph[e] / reviewsList.length) * 100;
                            const formattedPercentage =
                            reviewsList.length > 0
                                ? (Number.isInteger(percentage)
                                    ? percentage
                                    : percentage.toFixed(2)) + "%"
                                : "0%";
                            return (
                            <span key={i}>
                                <span> {e} </span>
                                <ProgressBar now={ratingGraph[e]} max={reviewsList.length} />
                                <span> {formattedPercentage} </span>
                            </span>
                            );
                        })}
                        </div>
                    </>
                    )}

                </div>
                </div>

                <div className="col-md-6">
                <div className="old-reviews">
                    {reviewsList.filter((item) => item.user.uuid !== userData.user.uuid).length > 0 && (
                    <>
                        <h5> Top reviews </h5>
                        <div className="review-item-list">
                        {reviewsList.filter((item) => item.user.uuid !== userData.user.uuid).map((e, i) => {
                            let splitName = e.user.name.trim().split(" ");
                            let userName = splitName.length > 1 ? splitName[0].split("")[0] + splitName[1].split("")[0] : splitName[0].split("")[0];
                            return (
                                <div className="review-item" key={i + 1}>
                                <div>
                                    <span className="img-star">
                                    <span className="initials"> {userName} </span>
                                    </span>
                                    <span className="review-name-detail">
                                    <span className="forrating">
                                        {e.user.name}
                                        <Rating initialValue={e.data.rating} readonly={true} />
                                    </span>
                                    <span className="review-date" style={{ opacity: "0.8" }}>
                                        
                                        Reviewed on {moment(e.createdAt).format(
                                        "MMM DD, YYYY"
                                        )}
                                    </span>
                                    </span>
                                </div>
                                <p>{e.data.review}</p>
                                </div>
                            );
                            })}
                        </div>
                    </>
                    )}
                </div>
                </div>

            </div>
        </div>
  )


}

export default ModuleReview;